import React, { useEffect } from 'react'
import LoadPanel from 'devextreme-react/load-panel'
import { redirectToArtemisID } from '../../api/auth'

export default function LoginFlow() {
	useEffect(() => {
		redirectToArtemisID('LoginFlow')
	}, [])

	return <LoadPanel visible={true} />
}
